export enum CommonGenericEvents {
	ORDER_BANNER = 'order_banner',
}
